/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'

function Template() {
	return (
		<div className='main-container'>
			<section id='quote__section'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-8'>
							<blockquote className='text-center'>
								We are on a mission to provide prosperity that
								multiplies, products and services that inspire,
								and awareness that transforms.
							</blockquote>
						</div>
					</div>
				</div>
			</section>
			<Section className=''>
				<div className='col-md-6 align-self-center'>
					<img src='https://placehold.it/600x400' alt='placeholder' />
				</div>
				<div className='col-md-6 align-self-center'>
					<h2>The Etho Story</h2>
					<p>
						The Etho is an online marketplace that connects
						conscious consumers directly with ethical brands and
						artisans. We partner with a range of sellers—so you can
						find the products that you want with the ethics that you
						need. To us, that means sustainable wages, safe working
						conditions, and environmentally conscious production.
					</p>
					<p>
						Sydney Sherman started The Etho to change the way people
						everywhere think about, and respond to, global
						poverty—through the things that we buy. Through The
						Etho, she envisions a world without poverty, where every
						person can thrive in a dignified, economically
						sustainable way. Shoppers make this possible by buying
						products that compensate disadvantaged artisans with a
						respectable wage for their work, and by supporting the
						market for ethically made goods. When you purchase from
						The Etho, you're helping us bring 100 million women out
						of poverty.
					</p>
				</div>
			</Section>
		</div>
	)
}

export default Template
